import styled from "@emotion/styled";
import { Button, Tooltip, CircularProgress } from "@mui/material";
import { usePdfViewer } from "context/PdfViewerContext";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "services/store";
import { OcrDataPage, setCurrentPage } from "features/appStateSlice";
import { useTranslation } from "react-i18next";

const SpinnerWrapper = styled("span")({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: 0
  });

const OcrBtn = ({ color, generateOcr }: any) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { pdfViewer } = usePdfViewer();
    const ocrData = useSelector((state: RootState) => state.appState.ocrData);

    if(!pdfViewer) return null;
    if(!ocrData) return null;

    const ocrDataPage = ocrData.pages.find((page: OcrDataPage) => page.pageNumber == pdfViewer.currentPageNumber);

    const onClickOCR = async() => {
        if(pdfViewer){
            await generateOcr(pdfViewer.currentPageNumber, true);
            dispatch(setCurrentPage(null));
        }
    };

    return (
        <Tooltip title={`${t("tooltip.showPageText")}`} arrow placement="top">
            <Button 
                disabled={ocrDataPage?.isLoading}
                color={`primary`}
                onClick={() => onClickOCR()}
                variant="text"
                sx={{
                boxShadow: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "none",
                padding: "0px 8px 0px 8px",
                minWidth: "0px",
                fontWeight: "bold",
                color: {color}
                }} 
            >
                {
                ocrDataPage?.isLoading ? (
                    <span>
                    <span>&nbsp;</span>
                    <SpinnerWrapper>
                        <CircularProgress size={12} sx={{ color: {color}, fontWeight: "bold" }} />
                    </SpinnerWrapper>
                    </span>
                ) : "OCR"
                }
            </Button>
        </Tooltip>
    )
};

export default OcrBtn;